<template>
  <div>
    <div v-if="loading" class="content__loader">
      <div class="loader">Loading...</div>
    </div>
    <transition name="fade">
      <div class="content" v-if="!loading">
        <h1 class="content__heading">{{ item.heading }}</h1>
        <div class="content__info">
          <span><a href="/" class="content__info-type">Domů</a> &gt; <a :href="'/' + item.type" class="content__info-type">{{ item.type }}</a> &gt; <em>{{item.heading | shorten}}</em></span>
          <span>{{ item.date | moment }}</span>
          <span>
            <span v-for="(tag, index) in item.tags" :key="index">
              #{{ tag }}
              <span v-if="index + 1 < item.tags.length"></span>
            </span>
          </span>
          <span>{{ item.customer }}</span>
        </div>
        <div class="content__slider" v-if="item.slideshow.length">
          <Slider :slides="item.slideshow"></Slider>
        </div>
        <div class="content__intro">{{item.intro}}</div>
        <div class="content__html" v-html="item.content"></div>
      </div>
    </transition>
  </div>
</template>

<script>
import axios from "axios";
import Slider from "@/components/Slider";

import moment from "moment";
moment.locale("cs");

export default {
  name: "Content",
  components: {
    Slider,
  },
  data() {
    return {
      item: {},
      loading: true,
    };
  },
  created() {
    axios
      .get(`items/atelier_projekty?fields=content,date,customer,heading,tags,type,intro,slideshow.directus_files_id.id,slideshow.directus_files_id.title&filter[slug][_eq]=${this.$route.params.slug}`)
      .then((res) => {
        if (res.status == 200) {
          this.item = res.data.data[0];
          this.loading = false;
        }
      })
      .catch(() => {
        window.location.replace('/' + this.$route.params.type);
      });
  },
  filters: {
    moment: function (date) {
      return moment(date).format("MMMM YYYY");
    },
    shorten: function (text) {
      var textArray = text.split(" ");
      if (textArray.length > 3) {
        text = textArray.slice(0,3).join(" ") + "..."
      }
      return text;
    }
  },
};
</script>
<style>
.content {
  padding: 0 48px;
}

.content > div {
  padding: 24px 0;
}

.content h1 {
  font-size: 4rem;
  text-align: center;
  letter-spacing: 0;
  margin: 64px 0 0 0;
}

.content h3 {
  font-size: 32px;
}

.content__info {
  text-align: center;
}

.content__info > span {
  padding: 0 12px;
}

.content__info-type {
  text-transform: capitalize;
}

.content__image {
  object-fit: cover;
  width: 100%;
  max-height: 60vh;
  border-radius: 48px;
}

/* Loader */
.content__loader {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100vw;
  height: 100vh;
  margin: auto;
}

div.content__html {
  padding-left: 48px;
  padding-right: 48px;
}

div.content__intro {
  font-size: 24px;
  padding-left: 48px;
  padding-right: 48px;
  padding-bottom: 0;
}

@media only screen and (min-width: 1200px) {
  .content {
    padding-left: 10vw;
    padding-right: 10vw;
  }
}

@media only screen and (max-width: 800px) {
  div.content__html {
    padding-left: 24px;
    padding-right: 24px;
  }
}

@media only screen and (max-width: 400px) {
  .content {
    padding: 0 24px;
  }

  div.content__html {
    padding-left: 12px;
    padding-right: 12px;
  }

  .content h1 {
  font-size: 3rem;
}
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 2s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
